import React from "react";
import {
  RadialBarChart,
  RadialBar,
  ResponsiveContainer,
  PolarAngleAxis,
} from "recharts";

interface PercentageCircleProps {
  percentage: number; // 传入 60 代表 60%
  label: string;
  color?: string;
}

export const PercentageChart = ({
  percentage = 60,
  color = "#3b82f6",
  label = "",
}: PercentageCircleProps) => {
  // Recharts 环形图需要数组结构
  const data = [{ value: percentage }];

  return (
    <div
      className="chart-percentage"
      style={{
        width: 200,
        height: 200,
        position: "relative",
        borderRadius: "50%",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart
          cx="50%"
          cy="50%"
          innerRadius="80%" /* 内环半径 */
          outerRadius="100%" /* 外环半径 */
          barSize={14} /* 进度条的粗细 */
          data={data}
          startAngle={90} /* 从正上方 12 点钟方向开始旋转 */
          endAngle={-270} /* 顺时针旋转一整圈 */
        >
          {/* 1. 背景底圈：用于衬托未满的 100% 轨道 */}
          <PolarAngleAxis
            type="number"
            domain={[0, 100]}
            angleAxisId={0}
            tick={false}
          />
          {/* 2. 真实的进度条 */}
          <RadialBar
            background={{
              fill: "#374151",
            }} /* 轨道未填满部分的颜色（暗灰色） */
            dataKey="value"
            cornerRadius={7} /* 给进度条两端加上圆角，更好看 */
            fill={color} /* 进度条高亮颜色 */
          />
        </RadialBarChart>
      </ResponsiveContainer>

      {/* 3. 正中间定位的百分比文字 */}
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
        }}
      >
        <div
          style={{ fontSize: "1.75rem", fontWeight: "bold", color: "#ffb38a" }}
        >
          {percentage}%
        </div>
        <div
          style={{
            fontSize: "0.75rem",
            color: "rgba(255,240,235,0.6)",
            marginTop: 2,
          }}
        >
          {label.toUpperCase()}
        </div>
      </div>
    </div>
  );
};
